// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TBrowseSyncSourceRequestPayload,
  TBrowseSyncSourceResponsePayload,
  TListKnowledgeBaseSyncsRequestPayload,
  TListKnowledgeBaseSyncsResponsePayload,
  TSaveSyncConnectionsRequestPayload,
  TSaveSyncConnectionsResponsePayload,
  TTriggerKnowledgeBaseSyncRequestPayload,
  TTriggerKnowledgeBaseSyncResponsePayload,
} from './kb-sync.types.ts';

export const createKbSyncApi = (transport: TApiTransport) => ({
  /** Browses a project's sync sources: credentials, sites, libraries and folders */
  browseSyncSource: (
    payload: TBrowseSyncSourceRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TBrowseSyncSourceRequestPayload,
      TBrowseSyncSourceResponsePayload
    >('/browse_sync_source', payload, options),

  /** Lists knowledge-base syncs */
  listKnowledgeBaseSyncs: (
    payload: TListKnowledgeBaseSyncsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TListKnowledgeBaseSyncsRequestPayload,
      TListKnowledgeBaseSyncsResponsePayload
    >('/list_knowledge_base_syncs', payload, options),

  /** Creates and edits a project's sync connections, all or nothing */
  saveSyncConnections: (
    payload: TSaveSyncConnectionsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TSaveSyncConnectionsRequestPayload,
      TSaveSyncConnectionsResponsePayload
    >('/save_sync_connections', payload, options),

  /** Triggers a knowledge-base sync */
  triggerKnowledgeBaseSync: (
    payload: TTriggerKnowledgeBaseSyncRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TTriggerKnowledgeBaseSyncRequestPayload,
      TTriggerKnowledgeBaseSyncResponsePayload
    >('/trigger_knowledge_base_sync', payload, options),
});
